<template>
    <div class="b-grid-group">
        <b-row>
            <template v-if="groupableFields.length == 0">
                <b-col md="8">
                    <h2 v-if="gridName">{{gridName}}</h2>
                    <slot name="gridName" v-if="!gridName"></slot>
                </b-col>
                <b-col md="4" class="text-right">
                    <slot name="actions"></slot>
                </b-col>
            </template>
            <template v-else>
                <b-col md="12">
                    <h2 v-if="gridName != ''">{{gridName}}</h2>
                </b-col>
                <b-col md="8">
                    <b-button :id="`grid_grouping_${_uid}`" size="sm" title="Nhóm dữ liệu theo cột" variant="primary" @click="">
                        <i class="fa fa-align-justify"></i>
                    </b-button>
                    <b-button-group>
                        <b-button v-for="field in options.groupBy" :key="field.key" @click="removeGroup(field)">
                            {{ field.label }}<i class="fa fa-remove"></i>
                        </b-button>
                    </b-button-group>
                </b-col>
                <b-col md="4" class="text-right">
                    <slot name="actions"></slot>
                </b-col>
            </template>
        </b-row>
        <b-table show-empty
                 responsive
                 :items="items? items : getItems"
                 :fields="options.fields"
                 :current-page="options.page"
                 :per-page="options.itemsPerPage"
                 :sort-by.sync="options.sortBy"
                 :sort-desc.sync="options.sortDesc"
                 :sort-direction="options.sortDirection"
                 :groupBy="options.groupBy"
                 no-sort-reset
                 striped
                 table-variant="light"
                 hover
                 bordered
                 :sticky-header="stickyHeader"
                 :filter="filter"
                 :filter-function="filterFunction"
                 :filter-included-fields="filterIncludedFields"
                 :selectable="selectable"
                 :select-mode="selectMode"
                 @row-selected="onRowSelected"
                 ref="bTable">
            <template v-slot:table-busy>
                <div class="text-center text-danger my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong>Loading...</strong>
                </div>
            </template>
            <template v-slot:top-row="{ columns }" v-if="options.groupBy.length > 0 && options.totalRows > 0">
                <td :colspan="columns" style="padding: 0; margin: 0; border: none">
                    <table width="100%" class="table table-dark table-dark-no-hover" style="padding: 0;margin: 0">
                        <tr v-for="(field, index) in options.groupBy">
                            <td v-for="i in index" width="20px"></td>
                            <td :colspan="options.groupBy.length - index">{{ field.label }} : {{ $refs.bTable.getGroupFieldValue(field, $refs.bTable.computedItems[0]) }}</td>
                        </tr>
                    </table>
                </td>
            </template>
            <template v-slot:head(_actions)>
                <span></span>
            </template>
            <template v-slot:head(_selected)="row">
                <!--<input type="checkbox" @change="selectAllRows" v-if="selectMode=='multi'" />-->
                <b-form-checkbox v-model="isCheckAll" @change="selectAllRows" v-if="selectMode=='multi'"></b-form-checkbox>
            </template>
            <template v-slot:cell(_selected)="row">
                <b-form-checkbox v-model="row.rowSelected" @change="selectRow(row)" v-if="isRowSelectable(row.item)"></b-form-checkbox>
            </template>
            <template v-slot:cell(_index)="row">
                {{ (options.page - 1) * options.itemsPerPage + row.index + 1 }}
            </template>
            <template v-slot:row-details="{ fields, item }">
                <table width="100%" class="table table-dark table-dark-no-hover" style="padding: 0;margin: 0">
                    <tr v-for="(field, index) in options.groupBy" v-if="item['_show_next_' + field.key]">
                        <td v-for="i in index" width="20px"></td>
                        <td :colspan="options.groupBy.length - index">{{ field.label }} : {{ item['_next_' + field.key] }}</td>
                    </tr>
                </table>
            </template>
            <template v-for="(_, slot) of $scopedSlots" v-slot:[slot]="scope">
                <slot :name="slot" v-bind="scope" />
            </template>
        </b-table>
        <b-row v-if="totalRows > 0">
            <b-form inline class="col-md-12">
                <b-col md="6">
                    Hiển thị bản ghi từ <b>{{ firstItem }}</b> đến <b>{{ lastItem }}</b> trong tổng số <b>{{ totalRows }}</b> bản ghi
                </b-col>
                <b-col md="6" class="my-1 pull-right input-group">
                    <label class="control-label ml-auto">Kích thước trang</label>
                    <b-form-select v-model="options.itemsPerPage" :options="options.pageOptions" style="flex:none; margin: 0px 5px;"></b-form-select>
                    <b-pagination align="right" :total-rows="totalRows" :per-page="options.itemsPerPage" v-model="options.page" class="my-0" />
                </b-col>
            </b-form>
        </b-row>

        <b-popover title="Nhóm dữ liệu bảng" :target="`grid_grouping_${_uid}`" v-if="groupableFields.length > 0"
                   triggers="click blur"
                   placement="topright">
            <table>
                <tr v-for="field in groupableFields" v-if="options.groupBy.indexOf(field) == -1">
                    <td><b-button size="sm" variant="primary" @click="addGroup(field)" style="width: 100%">{{ field.label }}</b-button></td>
                </tr>
            </table>
            <!--<ul style="list-style: none; padding-left: 0">
                <li v-for="col in groupableFields"><b-button>{{ col.label }}</b-button></li>
            </ul>-->
        </b-popover>
    </div>
</template>
<script>
    export default {
        name: 'BGrid',
        props: {
            gridOptions: {
                required: true,
            },
            items: {
                type: Array
            },
            dataUrl: {
                type: String,
                //required: true
            },
            autoLoad: {
                type: Boolean,
                default: true,
                required: false
            },
            filter: {
                type: String
            },
            filterFunction: {
                type: Function
            },
            filterIncludedFields: {
                type: Array
            },
            searchForm: {
            },
            stickyHeader: {
                type: [Boolean, String],
                required: false,
                //default: '500px'
                default: false
            },
            selectable: {
                type: Boolean,
                default() {
                    return false;
                }
            },
            selectMode: {
                type: String,
                default() {
                    return 'multi';
                }
            },
            isRowSelectable: {
                type: Function,
                default: function () {
                    return true;
                },
                required: false
            },
            gridName: {
                type: String,
                required: false
            },
            showIndex: {
                type: Boolean,
                default: true
            },
            showActions: {
                type: Boolean,
                default: true
            },
            onItemDataBound: {
                type: Function,
                required: false
            },
            paginationNormalize: {
                type: Function,
                required: false
            },
            resultNormalize: {
                type: Function,
                required: false
            },
            onGridRefresh: {
                type: Function,
                required: false
            }
        },
        data() {
            return {
                isBusy: false,
                isInitialized: false,
                selectedRows: [],
                isCheckAll: false,
                options: {
                    fields: [],
                    page: 1,
                    itemsPerPage: 10,
                    totalRows: this.items ? this.items.length : 0,
                    pageOptions: [10, 20, 50, 100, 1000],
                    sortBy: '',
                    sortDesc: false,
                    sortDirection: 'asc',
                    groupBy: []
                }
            }
        },
        computed: {
            firstItem() {
                return (this.options.page - 1) * this.options.itemsPerPage + 1;
            },
            lastItem() {
                return Math.min(this.totalRows, this.options.page * this.options.itemsPerPage);
            },
            totalRows() {
                if (this.items && this.items.length > 0 && this.$refs.bTable) {
                    return this.$refs.bTable.sortedItems.length;
                } else {
                    return this.options.totalRows;
                }
            },
            groupableFields() {
                return this.options.fields.filter(x => x.groupable);
            },
        },
        created: function () {
            Object.assign(this.options, this.gridOptions);

            this.initColumns();
        },
        methods: {
            initColumns() {
                if (this.showIndex && this.options.fields.find(x => x.key == '_index') == null) {
                    this.options.fields.unshift({ key: '_index', label: 'STT', sortable: false, thAttr: { width: 50 } });
                }

                if (this.showActions && this.options.fields.find(x => x.key == '_actions') == null) {
                    this.options.fields.push({ key: '_actions', label: '', sortable: false, thAttr: { width: 70 } });
                }

                var checkboxField = this.options.fields.find(x => x.key == '_selected');
                if (this.selectable && checkboxField == null) {
                    this.options.fields.unshift({ key: '_selected', label: '', sortable: false, thAttr: { width: 35 } });
                } else if (!this.selectable && checkboxField != null) {
                    this.options.fields.remove(checkboxField);
                }

            },
            addGroup(field) {
                this.options.groupBy.push(field);
                this.options.fields.unshift({ key: `_group_${this.options.groupBy.length}`, label: '', class: 'table-dark-no-hover', variant: 'dark', sortable: false, thAttr: { width: '20px' } })
            },
            removeGroup(field) {
                this.options.groupBy.remove(field);
                this.options.fields.splice(0, 1);
            },
            selectAllRows(e) {
                var tbl = this.$refs.bTable;
                if (!this.isCheckAll) {
                    //this.$refs.bTable.selectAllRows();
                    var vm = this;

                    if (tbl.isSelectable && tbl.computedItems.length > 0) {
                        tbl.selectedLastClicked = -1
                        tbl.selectedRows = tbl.selectableIsMultiSelect ? tbl.computedItems.map(item => vm.isRowSelectable(item)) : [true];
                    }

                } else {
                    tbl.clearSelected();
                }
            },
            onRowSelected(items) {
                this.selectedRows = items;
            },
            selectRow(row) {
                if (row.rowSelected) {
                    this.$refs.bTable.unselectRow(row.index);
                } else {
                    this.$refs.bTable.selectRow(row.index);
                }
            },
            getFormData() {
                var pagination;
                if (this.paginationNormalize) {
                    pagination = this.paginationNormalize(this.options)
                } else {
                    pagination = {
                        page: this.options.page,
                        itemsPerPage: this.options.itemsPerPage,
                        sortBy: this.options.sortBy,
                        sortDesc: this.options.sortDesc
                    };
                }

                var formData = $.extend({}, pagination, this.searchForm);

                return formData;
            },
            getItems(ctx) {
                var vm = this;

                if (!this.autoLoad && !this.isInitialized) {
                    this.isInitialized = true;
                    return Promise.resolve();
                }

                var formData = this.getFormData();
                return this.$services.get(this.dataUrl, formData, { showLoading: false }).then((response) => {

                    if (vm.onGridRefresh) {
                        vm.onGridRefresh(response);
                    }
                    vm.options.totalRows = response.totalRows;

                    if (vm.resultNormalize) {
                        return vm.resultNormalize(vm, response);
                    } else {

                        if (response.data && response.data.length > 0) {
                            response.data.forEach((item) => {
                                if (vm.onItemDataBound) {
                                    vm.onItemDataBound(item);
                                }
                            });
                        }


                        if (vm.options.groupBy.length > 0) {
                            return vm.$refs.bTable.group(response.data);
                        }

                        return response.data;
                    }
                }, () => []);
            },
            refresh: function () {
                if (this.items && this.items.length > 0) {
                    this.options.totalRows = this.items.length;
                }
                if (this.options.page != 1) {
                    this.options.page = 1;
                } else {
                    this.$refs.bTable.refresh();
                }
            }
        },
        watch: {
            items(value) {
                this.options.totalRows = this.items.length;
            },
            //'options.groupBy': function () {
            //    this.refresh();
            //},
            //showActions() {
            //    if (this.showActions && this.options.fields.find(x => x.key == '_actions') == null) {
            //        this.options.fields.push({ key: '_actions', label: '', sortable: false, thAttr: { width: 70 } });
            //    }

            //    if (!this.showActions && this.options.fields.find(x => x.key == '_actions') != null) {
            //        this.options.fields.remove(this.options.fields.find(x => x.key == '_actions'));
            //    }
            //}
        }
    }
</script>
